export default "__VITE_ASSET__Bupiu1UF__"